document.addEventListener("DOMContentLoaded", () => {
  let lastScrollTop = 0; // Store the last scroll position
  let isMobile = window.innerWidth < 768;

  const header = document.querySelector("header");
  const mobileMenuBtn = document.getElementById("mobile-menu-btn");
  const navContainer = document.querySelector(".nav-container");

  const toggleMobileMenu = () => {
    const isActive = navContainer.classList.contains("mobile-menu-active");
    if (isActive) {
      navContainer.classList.remove("mobile-menu-active");
      mobileMenuBtn.classList.remove("rotate-plus");
      enableScroll();
    } else {
      navContainer.classList.add("mobile-menu-active");
      mobileMenuBtn.classList.add("rotate-plus");
      disableScroll();
    }
  };

  const onScroll = () => {
    isMobile = window.innerWidth < 768;
    if (!isMobile) {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 64) {
        if (scrollTop > lastScrollTop) {
          // SCROLLING DOWN
          header.classList.add("hide-nav-container");
        } else if (scrollTop < lastScrollTop) {
          // SCROLLING UP
          header.classList.remove("hide-nav-container");
        }
      } else {
        header.classList.remove("hide-nav-container");
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Prevent negative values
    }
  };

  mobileMenuBtn.addEventListener("click", toggleMobileMenu);

  window.addEventListener("scroll", onScroll);
});
